exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payments-chart .payments {\n  background-color: white; }\n\n.payments-chart h3 {\n  font-size: 125%; }\n\n.payments-chart .text-size {\n  font-size: 70%;\n  font-style: italic; }\n\n.payments-chart .capitalize {\n  text-transform: capitalize; }\n\npayments-chart p-calendar * {\n  height: 100% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/payments/payments-chart.component.scss
// module id = ../../../../../src/app/components/payments/payments-chart.component.scss
// module chunks = main